import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, CheckSquare, DollarSign, TrendingUp, Lightbulb, ShieldAlert } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: BookOpen,
    text: 'Guía PDF completa y optimizada para leer rápido.'
  }, {
    icon: Clock,
    text: 'Plantilla de validación exprés para probar tu idea en 24 horas.'
  }, {
    icon: CheckSquare,
    text: 'Checklist de lanzamiento en 7 días con tareas diarias y claras.'
  }, {
    icon: DollarSign,
    text: 'Matriz de precios iniciales para ajustar tu servicio o producto.'
  }, {
    icon: TrendingUp,
    text: 'Hoja de ruta para escalar: cómo automatizar tus siguientes pasos.'
  }, {
    icon: Lightbulb,
    text: 'Ejemplos reales de micro-emprendimientos rentables hoy.'
  }, {
    icon: ShieldAlert,
    text: 'Mini-guía de errores que debes evitar al empezar.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-brand-light text-slate-900" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4" data-id="element-141">
            ¿Qué incluye esta guía?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-142">
            Todo lo que necesitas para pasar de la idea a la acción.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-143">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 hover:shadow-md transition-shadow flex items-start gap-4" data-id="element-144">
              <div className="p-3 bg-brand-darker text-brand-accent rounded-xl shrink-0" data-id="element-145">
                <item.icon className="w-6 h-6" data-id="element-146" />
              </div>
              <p className="text-slate-700 font-medium leading-snug pt-1" data-id="element-147">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}